import styled from "styled-components";
import facebookIcon from "../images/facebook.svg";

const FacebookButton = styled.button`
  display: block;
  width: 100%;
  height: 46px;

  background-color: #4267b2;
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 3px;
  outline: none;
  border: none;
  cursor: pointer;

  background-image: url(${facebookIcon});
  background-position: 20px center;
  background-size: 25px 25px;
  background-repeat: no-repeat;

  padding: 0;
  margin-bottom: 0.8rem;
  box-shadow: 0px 0px 5px 0 rgba(0, 0, 0, 0.1);

  &:hover {
    background-color: #3b5ca0;
  }
`;

export default FacebookButton;



// WEBPACK FOOTER //
// ./src/components/FacebookButton.jsx